import styled, { css } from 'styled-components';
import { Flex } from '@m/alchemy-ui/Flex';
import { Checkbox } from '@m/alchemy-ui/Checkbox';

function truncatedText() {
  return css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `;
}

export const StyledMoreItems = styled.span`
  white-space: nowrap;
  color: #0075ff;
  font-size: 12px;
  font-weight: 600;
`;

export const StyleTooltipCustomParam = styled.span`
  min-width: 0px;
  max-width: 100%;
  ${truncatedText()}
`;

export const StyledVerticalStack = styled(Flex)`
  max-width: 300px;
`;

export const StyledLabel = styled.span`
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 400;
`;

export const StyledTruncatedLabel = styled(StyledLabel)`
  ${truncatedText()}
`;

export const StyledNote = styled.span`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 1.4;
`;

export const StyledCheckbox = styled(Checkbox)`
  span {
    color: #8c8c8c;
    font-size: 12px;
  }
`;
